import React from 'react';

import { useFormState } from 'react-final-form';
import { useDebounce } from 'use-debounce';

import { Nullable } from '@clearverify/types';

import { useGetMyVerifyRequestTotalChargeQuery, VerificationRequestType } from 'src/api';
import { useVerificationRequestFormData } from 'src/hooks/verificationRequest';

import { VerificationRequestCreateFormValues } from '../types';

import { PaymentBlock } from './PaymentBlock';

interface InboxItemContentPaymentBlockProps {
  inboxItemId: Nullable<string>;
  verificationReportType: Nullable<VerificationRequestType>;
}

export const InboxItemContentPaymentBlock: React.FC<InboxItemContentPaymentBlockProps> = props => {
  const { inboxItemId, verificationReportType } = props;

  const { setIsTotalChargeLoading } = useVerificationRequestFormData();

  const { values, submitting } = useFormState<VerificationRequestCreateFormValues>();

  const [{ permissiblePurposeId }] = useDebounce(values, DEBOUNCE_DELAY);

  const { data, loading } = useGetMyVerifyRequestTotalChargeQuery({
    variables: {
      inboxItemId: inboxItemId || '',
      permissiblePurposeId: permissiblePurposeId || '',
      verificationReportType,
    },
    skip: !permissiblePurposeId || !inboxItemId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  React.useEffect(() => {
    setIsTotalChargeLoading(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const { totalCharge, isReverification } = React.useMemo(
    () =>
      data?.getMyVerifyRequestTotalCharge || {
        totalCharge: 0,
        isReverification: false,
      },
    [data?.getMyVerifyRequestTotalCharge],
  );

  if (!inboxItemId) return null;

  return (
    <PaymentBlock
      totalCharge={totalCharge}
      isReverification={isReverification}
      loading={loading}
      submitting={submitting}
    />
  );
};

const DEBOUNCE_DELAY = 1000;
